import { EnvironmentConfig } from "~/modules/config";

export const getEnvironmentConfig = (): EnvironmentConfig => ({
    twilioServiceLoginUrl: "https://flex.twilio.com/admin",
    ...window.__TWILIO_FLEX_SDK__?.environmentConfig
});
